import { render, staticRenderFns } from "./xljk.vue?vue&type=template&id=09c5b477&scoped=true"
import script from "./xljk.vue?vue&type=script&lang=js"
export * from "./xljk.vue?vue&type=script&lang=js"
import style0 from "./xljk.vue?vue&type=style&index=0&id=09c5b477&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c5b477",
  null
  
)

export default component.exports